module.exports = __webpack_public_path__ + "img/vegetable-rhubarb-350x184.c59dc028.jpg";